import { AUTH_ROUTES } from '../../constants/_routes'
import auth_types from '../../constants/authTypes'
import { axios, resetUrl } from '../../services'

const request_password_reset = () => {
  return {
    type: auth_types.REQUEST_PASSWORD.reset
  }
}

const request_password_request = () => {
  return {
    type: auth_types.REQUEST_PASSWORD.request
  }
}

const request_password_success = () => {
  return {
    type: auth_types.REQUEST_PASSWORD.success
  }
}

const request_password_failure = (messages) => {
  return {
    type: auth_types.REQUEST_PASSWORD.failure,
    payload: messages
  }
}

const request_password = (logindata) => {
  return function (dispatch ) {
    // REQUEST
    dispatch(request_password_request())

    const { email } = logindata
    axios(
      {
        url: AUTH_ROUTES.request_password,
        method: 'POST',
        data: {
          user: {
            email: email
          },
          host: resetUrl
        }
      }
    ).then( response => {
      // SUCCESS
      dispatch( request_password_success( ) )
    }).catch( error => {
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else if (error.response && error.response.data) {
        errors = [error.response.data]
      } else {
        errors = ["Password reset request failed."]
      }
      // FAILURE
      dispatch( request_password_failure( errors ) )
    })
  }

}

export {
  request_password,
  request_password_reset
}



// WEBPACK FOOTER //
// ./src/js/actions/auth/request_password.js